import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import _ from 'lodash';

const Context = React.createContext();

export const MlsProvidersProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `MlsProvider/${props.mlsProviderId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `MlsProvider`, method: 'POST', payload: props, multipart: true, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `MlsProvider/${props.mlsProviderId}`, method: 'PUT', payload: props, multipart: true, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        let url = 'MlsProvider';

        if (!_.isEmpty(props)) {
            if (_.isNumber(props.franchiseId)) {
                url += `/Franchise/${props.franchiseId}`;
            } else if (_.isNumber(props.branchOfficeId)) {
                url += `/BranchOffice/${props.branchOfficeId}`;
            }
        
            if (!_.isUndefined(props.allowInactive)) {
                url += `?allowInactive=${props.allowInactive}`;
            }
        }

        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `MlsProvider/${props.mlsProviderId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMlsProviderStore = () => React.useContext(Context);
